import { TCoordinatePoint } from '../fields/isCoordinatePoint';
import { TPartnerLocation } from '../partnershipCompany/isPartnerLocation';

export default function hasCoordinate(
	location: TPartnerLocation
): location is TPartnerLocation & { coordinate: TCoordinatePoint } {
	return location.coordinate !== undefined && location.coordinate !== null;
}
